/** Split only at the reviewed hero/status boundary; retain every source byte. */
export function splitHomeAtHero(html: string): [string, string] {
  const boundary = '</section>\n<div class="public-status">';
  const position = html.indexOf(boundary);
  if (position < 0) return [html, ''];
  const end = position + '</section>'.length;
  return [html.slice(0, end), html.slice(end)];
}

/** Insert editorial React content before the reviewed member-entry section. */
export function splitHomeAtMemberEntry(html: string): [string, string] {
  const boundary = '<section class="section member-entry-section"';
  const position = html.indexOf(boundary);
  if (position < 0) return [html, ''];
  // The member section is inside .story. A raw split leaves one open div in
  // the first React HTML island and a stray closing div in the second. The
  // HTML parser then moves the intervening React sections on the server,
  // causing hydration to discard the page. Keep each island balanced.
  const storyStart = '<div id="your-journey" class="story">';
  if (html.indexOf(storyStart) >= 0 && html.indexOf(storyStart) < position) {
    return [html.slice(0, position) + '</div>', '<div class="story">' + html.slice(position)];
  }
  return [html.slice(0, position), html.slice(position)];
}
